import { apiClient } from "services/api/client";
import { IFeatureConfig } from "../../types";

export const getConfig = async () => {
  const url = "administrator/config";
  const response = await apiClient.get<IFeatureConfig[]>(url);
  return response.data;
};
